import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Star } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            {/* Company Info */}
            <div className="footer-col">
              <h3 className="footer-title">{companyInfo.name}</h3>
              <p className="footer-description">{companyInfo.description}</p>
              <div className="rating-badge">
                <Star size={20} fill="currentColor" />
                <span className="rating-value">{companyInfo.rating}</span>
                <span className="rating-text">({companyInfo.reviewCount}+ Reviews)</span>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-col">
              <h4 className="footer-heading">Quick Links</h4>
              <ul className="footer-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/projects">Projects</Link></li>
                <li><Link to="/testimonials">Testimonials</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            {/* Services */}
            <div className="footer-col">
              <h4 className="footer-heading">Our Services</h4>
              <ul className="footer-links">
                <li><Link to="/services">High-Rise Construction</Link></li>
                <li><Link to="/services">Commercial Construction</Link></li>
                <li><Link to="/services">Residential Construction</Link></li>
                <li><Link to="/services">Civil Contracting</Link></li>
                <li><Link to="/services">Project Management</Link></li>
                <li><Link to="/services">Construction Consulting</Link></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="footer-col">
              <h4 className="footer-heading">Contact Us</h4>
              <ul className="footer-contact">
                <li>
                  <MapPin size={18} />
                  <span>{companyInfo.address}<br />{companyInfo.location}</span>
                </li>
                <li>
                  <Phone size={18} />
                  <a href={`tel:${companyInfo.phone}`}>{companyInfo.phone}</a>
                </li>
                <li>
                  <Mail size={18} />
                  <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} {companyInfo.name}. All rights reserved.</p>
            <p className="footer-credits">Building Excellence in Hyderabad's Skyline</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
